import {SETTINGS_KEY, USER_KEY} from "@/helpers/utils";

export default {
    // Auth getters
    userWithSettings(state){
        let user = state.loggedInUser;
        if (!user && sessionStorage.getItem(USER_KEY)) {
            const userStr = sessionStorage.getItem(USER_KEY);
            user = JSON.parse(userStr);
        }
        let settings = state.userSettings;
        if (!settings && sessionStorage.getItem(SETTINGS_KEY)) {
            const settingsStr = sessionStorage.getItem(SETTINGS_KEY);
            settings = JSON.parse(settingsStr);
        }

        return {...user, ...settings};
    },
    userSettings(state) {
      if (!state.userSettings && sessionStorage.getItem(SETTINGS_KEY)) {
        const settingsStr = sessionStorage.getItem(SETTINGS_KEY);
          return JSON.parse(settingsStr);
        }
        return state.userSettings;
    },
    userSettingsLoading(state) {
        return state.userSettingsLoading;
    },
    usersWhoConsentedToSharing(state) {
        return state.shareableIds;
    },

    // Search getters
    searchStatus(state) {
        return state.searchStatus;
    },
    searchResults(state) {
        return state.searchResults;
    },
    canLoadMore(state) {
        return state.moreToLoad;
    },
    numSearchResults(state) {
        return state.numSearchResults;
    },

    // blog getters
    blogPosts(state) {
        return state.blogPosts;
    },
    blogStatus(state) {
        return state.blogStatus;
    },
    postToEdit(state) {
        return state.postToEdit;
    }
}